import { useCallback, useState } from "react"
import getScrollbarSize from '@material-ui/core/utils/getScrollbarSize'

export function getPageScrollX() {
  if (typeof window === 'undefined') { return NaN; } // ¯\_(ツ)_/¯

  if (window.pageXOffset !== undefined) {
    return window.pageXOffset;
  }

  return document && (document.documentElement || document.body.parentNode || document.body).scrollLeft;
}

export function getPageScrollY() {
  if (typeof window === 'undefined') { return NaN; } // ¯\_(ツ)_/¯

  if (window.pageYOffset !== undefined) {
    return window.pageYOffset;
  }

  return document && (document.documentElement || document.body.parentNode || document.body).scrollTop;
}

export function removeNode(node) {
  if (node && node.parentNode) {
    node.parentNode.removeChild(node);
  }
}

const isSmoothScrollSupported = document && ('scrollBehavior' in document.documentElement.style);

export function scrollToElem(elem, offset = 0, behavior = 'smooth') {
  const clientRect = elem?.getBoundingClientRect();
  const elemTop = clientRect?.top ?? 0;

  if (isSmoothScrollSupported) {
    window.scrollTo({
      top : elemTop + getPageScrollY() + offset,
      left: 0,
      behavior
    });
  } else {
    window.scrollTo(0, elemTop + getPageScrollY() + offset);
  }
}

export function scrollElemTo(elem, top, left) {
  if (isSmoothScrollSupported) {
    elem.scrollTo({
      top,
      left,
      behavior: 'smooth'
    });
  } else {
    elem.scrollTo(left, top);
  }
}

export function sendEvent(target, eventName) {
  if (typeof document === 'undefined') { return; }

  if (document.createEventObject) {
    return target.fireEvent('on' + eventName);
  } else {
    const evt = document.createEvent('HTMLEvents');
    evt.initEvent(eventName, false, true);
    return target.dispatchEvent(evt);
  }
}

const SCRIPT = 'script';

export function addRemoteScript(src) {
  return new Promise(function (resolve, reject) {
    if (!document) { reject(); }

    const firstScript = document.getElementsByTagName(SCRIPT)[0];
    const js = document.createElement(SCRIPT);
    js.src = src;
    js.onload = resolve;
    js.onerror = reject;
    firstScript.parentNode.insertBefore(js, firstScript);
  });
}

const DEFAULT_BROWSER_HEADER_HEIGHT = 22;
const POPUP_VERTICAL_POSITION_RATIO = 2.5;

export function openPopupWindow({ url, width, height }) {
  if (!window || !document) { return null; }

  const screenX = typeof window.screenX === 'undefined' ? window.screenLeft : window.screenX;
  const screenY = typeof window.screenY === 'undefined' ? window.screenTop : window.screenY;
  const outerWidth = typeof window.outerWidth === 'undefined' ? document.body.clientWidth : window.outerWidth;
  const outerHeight = typeof window.outerHeight === 'undefined' ? (document.body.clientHeight - DEFAULT_BROWSER_HEADER_HEIGHT) : window.outerHeight;
  const left = parseInt(screenX + ((outerWidth - width) / 2), 10);
  const top = parseInt(screenY + ((outerHeight - height) / POPUP_VERTICAL_POSITION_RATIO), 10);
  const features = [
    'width=' + width,
    'height=' + height,
    'left=' + left,
    'top=' + top,
    'personalbar=0',
    'toolbar=0',
    'scrollbars=1',
    'resizable=1',
  ];

  const win = window.open(url, null, features.join(','));

  if (win) {
    win.focus();
  }

  return win;
}

export function useHtmlOverflow() {
  const [initialOverflow, setInitialOverflow] = useState('')

  const setOverflowHidden = useCallback((set) => {
    const style = document?.getElementsByTagName('body')[0].style

    if (set) {
      setInitialOverflow(style.overflow)
      style.overflow = 'hidden'
      style.paddingRight = getScrollbarSize() + 'px'
    } else {
      style.overflow = initialOverflow
      style.paddingRight = ''
    }
  }, [initialOverflow, setInitialOverflow])



  return setOverflowHidden
}

export const KEYCODE_ENTER = 13;
export const KEYCODE_ESCAPE = 27;
export const KEYCODE_SPACE = 32;
